
import http from "./client"
import ILessonTheme from "../typings/ILessonModule";
import IAuthorLesson, { IStudentLesson, TLessonType } from "../typings/Lesson";
import ILessonModule from "../typings/ILessonModule";


interface ILessonsListParams {
  course_id?: number | string;
  themeId?: number | string;
  page?: number;
  limit?: number;
  drafts?: boolean;
  search?: string; // поисковый запрос
  withStudentsCount?: boolean; // возвращать кол-во студентов
  onlyDoneStudents?: boolean; // кол-во студентов только прошедших урок
  withHomeworksCount?: boolean; // кол-во дз на проверку
  withSettings?: boolean;
}

interface ILessonsListResponse<T = IAuthorLesson> {
  success: boolean;
  errorMessage?: string;
  search?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<T>;
}

/**
 * Список уроков для аккаунта автора
 */
async function authorList(queryParams: ILessonsListParams): Promise<ILessonsListResponse> {
  const response = await http.get<ILessonsListResponse>('/api/lesson/author-list', {
    params: queryParams
  });
  return response.data
}

async function studentList(queryParams: ILessonsListParams): Promise<ILessonsListResponse<IStudentLesson>> {
  const response = await http.get<ILessonsListResponse<IStudentLesson>>('/api/lesson/student-list', {
    params: queryParams
  });
  return response.data
}


interface ILessonsByIdQueryParams {
  id: number | string;
  course_id?: number | string
}

interface ILessonsByIdResponse {
  success: boolean;
  errorMessage?: string;
  data?: IAuthorLesson;
}

async function byId(queryParams: ILessonsByIdQueryParams): Promise<IAuthorLesson> {
  const response = await http.get<ILessonsByIdResponse>('/api/lesson/get', {
    params: queryParams,
  });
  return response.data.data;
}

async function authorById(queryParams: ILessonsByIdQueryParams): Promise<IAuthorLesson> {
  const response = await http.get<ILessonsByIdResponse>('/api/lesson/author-by-id', {
    params: queryParams,
  });
  return response.data.data;
}

interface ILessonsByThemeQueryParams {
  course_id?: number | string;
  search?: string;
}

interface ILessonsByThemeResponse {
  themes: Array<ILessonTheme>
}

/**
 * Список уроков сгруппированный по темам
 */
async function byTheme(queryParams: ILessonsByThemeQueryParams): Promise<Array<ILessonModule>> {
  const response = await http.get<ILessonsByThemeResponse>('/api/lesson/by-theme', {
    params: queryParams
  });
  //@ts-ignore
  return response.data.themes
}


async function copy(lessonsIds: number[], course_id: number | string, theme_id: number | string) {
  const response = await http.post('/api/lesson/copy', {
    lessons: lessonsIds,
    theme_id: theme_id,
    course_id: course_id
  });
  return response.data;
}

async function create(courseId: string| number, moduleId: string | number, type: TLessonType, settings?: any) {
  const response = await http.post('/api/lesson/save',{
    course_id: courseId,
    moduleId,
    type,
    ...settings
  });

  return response.data;
}

async function update(courseId: string| number, moduleId: string| number, lesson: Partial<IAuthorLesson>): Promise<IAuthorLesson> {
  const response = await http.post('/api/lesson/save', {
    course_id: courseId,
    moduleId,
    ...lesson,
  })
  return response.data.data
}

async function remove(courseId: string | number, lessonId: string | number, withExternal: boolean = false){
  const response = await http.post('/api/lesson/delete', {
    course_id: courseId,
    id: lessonId,
    withExternal: withExternal
  });
  return response;
}

const lessons = {
  authorById, byId, byTheme, copy, authorList, studentList, create, update, remove
}

export default lessons;